import { useAuthModalContext } from '@dreamstack/auth'
import { useTranslation } from '@dreamstack/i18n'
import type { FunctionComponent } from 'react'
import { SimpleMuiButton } from '../../layout/SimpleMuiButton'
import { AuthButtonArrow } from './AuthButtonArrow'

export const ConfirmationEmailSentSuccessPage: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  const t = useTranslation()
  const { resetModal } = useAuthModalContext()
  return (
    <>
      <span className="font-montserrat mb-px-40 ml:mb-px-48">
        {t('accentro:ConfirmationEmailSentText')}
      </span>
      <SimpleMuiButton
        onClick={resetModal}
        color="primary"
        variant="contained"
        type="button"
      >
        {t('accentro:continueOnAccentro')}
        <AuthButtonArrow />
      </SimpleMuiButton>
    </>
  )
}
